import { HelpCircle } from "lucide-react";
import React, { MouseEvent } from "react";

import { IgTooltip, IgTypography } from "@intelligems/ig-theme";
import { WidgetType } from "@intelligems/ig-types";
import { Box, Grid, useTheme } from "@mui/material";

interface ColorThemeHeaderProps {
  primaryColor: string;
  onColorChange: (field: string, event: MouseEvent<HTMLElement>) => void;
}

export const ColorThemeHeader = ({
  primaryColor,
  onColorChange,
}: ColorThemeHeaderProps) => {
  const theme = useTheme();

  const getPrimaryFieldName = () => "theme.picker";

  return (
    <Grid item xs={3}>
      <Grid item container direction="column" spacing={3}>
        <Grid
          item
          container
          alignItems="center"
          direction={"row"}
          columnSpacing={1}
        >
          <Grid item>
            <IgTypography fontWeight="600">Color theme</IgTypography>
          </Grid>
          <Grid item>
            <IgTooltip
              title="Sets the primary color for this theme. All swatches use this color in varying opacities."
              arrow={true}
              placement="top"
            >
              <HelpCircle style={{ marginTop: "4px" }} size={16} />
            </IgTooltip>
          </Grid>
        </Grid>
        <Grid item direction="column" spacing={3}>
          <Box
            onClick={(e) => onColorChange(getPrimaryFieldName(), e)}
            sx={{
              width: 100,
              height: 100,
              backgroundColor: primaryColor,
              borderRadius: "8px",
              border: `1px solid ${theme.igBorders.core.default}`,
              cursor: "pointer",
              "&:hover": {
                transform: "scale(1.02)",
                boxShadow: theme.igShadows.high,
              },
              transition: "all 0.2s ease",
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
